import React from "react";
// react library for routing
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar";
import Sidebar from "components/Sidebar/Sidebar";
import routes from "routes";
import { ROLES } from "components/Common/constants";
import { DEFAULT_ROUTES } from "components/Common/constants";

function Admin() {
  const [sidenavOpen, setSidenavOpen] = React.useState(false); //window.innerWidth > 768
  const location = useLocation();
  const mainContentRef = React.useRef(null);

  //use for default redirect
  const local = localStorage.getItem("p");
  const role = JSON.parse(local)?.role;
  const matchedKey = Object.keys(ROLES).find((key) => ROLES[key] === role);
  const redirect = DEFAULT_ROUTES[matchedKey] || "/customer/dashboard";

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/customer") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  // toggles collapse between mini sidenav and normal
  const toggleSidenav = (e) => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };

  return (
    <>
      <Sidebar
        routes={routes}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        logo={{
          innerLink: "/",
          imgSrc: require("assets/img/sample-icon.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContentRef}>
        <AdminNavbar
          theme={"light"}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          brandText={location.pathname}
        />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to={redirect} replace />} />{" "}
          {/* /a/dashboard */}
        </Routes>
      </div>
      {sidenavOpen ? (
        <div className="backdrop d-xl-none" onClick={toggleSidenav} />
      ) : null}
    </>
  );
}

export default Admin;
